/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ContextualMenu, Link } from '@fluentui/react';
import { textFieldStyles } from '../styles';

export function DynamicTextExtention(props) {
  const { i18n, onTextFieldChange, cachedValue } = props;

  const [showContextualMenu, setShowContextualMenu] = useState(false);
  const [target, setTarget] = useState(null);
  const linkRef = React.useRef(null);
  const onShowContextualMenu = useCallback((e) => {
    e.preventDefault();
    setShowContextualMenu(true);
    setTarget(e.target);
  }, []);
  const onHideContextualMenu = useCallback(() => setShowContextualMenu(false), []);

  const menuItems = [{
    key: '{param1}',
    text: ` ${i18n.getString(_TL_('Placeholder {param1}'))}`,
    onClick: e => onTextFieldChange(e, `${cachedValue}{param1}`),
  }, {
    key: '{param2}',
    text: ` ${i18n.getString(_TL_('Placeholder {param2}'))}`,
    onClick: e => onTextFieldChange(e, `${cachedValue}{param2}`),
  }, {
    key: '{param3}',
    text: ` ${i18n.getString(_TL_('Placeholder {param3}'))}`,
    onClick: e => onTextFieldChange(e, `${cachedValue}{param3}`),
  }];

  return (
    <React.Fragment>
      <Link
        componentRef={linkRef}
        onClick={onShowContextualMenu}
        styles={textFieldStyles({}).dynamicLink}
        aria-expanded={showContextualMenu}
      >
        {i18n.getString(_TL_('dynamic text'))}
      </Link>
      <ContextualMenu
        items={menuItems}
        hidden={!showContextualMenu}
        target={target}
        onItemClick={onHideContextualMenu}
        onDismiss={onHideContextualMenu}
      />
    </React.Fragment>
  );
}

DynamicTextExtention.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  cachedValue: PropTypes.string.isRequired,
};
